module.exports = __webpack_public_path__ + "static/media/create-payment-icon.62a96886.png";